function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import { filterMixin } from '@/mixins/filter_mixin';
import { mapState } from 'vuex';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import { localPaginationMixin } from '@/mixins/local_pagination';
import MyAccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import tasks from '@/js/tasks';
import ProductizeTransformedAttributesCreate from '@/apps/attributes/modules/use_cases/components/ProductizeTransformedAttributesCreate.vue';
import ProductizeTransformedAttributeDetail from '@/apps/attributes/modules/use_cases/ProductizeTransformedAttributeDetail.vue';
import ProductizeTransformedAttributeHistory from '@/apps/attributes/modules/use_cases/components/ProductizeTransformedAttributeHistory.vue';
export default {
  name: 'ProductizeUseCase',
  components: {
    ProductizeTransformedAttributeDetail: ProductizeTransformedAttributeDetail,
    ProductizeTransformedAttributesCreate: ProductizeTransformedAttributesCreate,
    ProductizeTransformedAttributeHistory: ProductizeTransformedAttributeHistory
  },
  mixins: [filterMixin, localPaginationMixin, useCaseListMixin],
  data: function data() {
    return {
      parentTransformationType: null,
      forbiddenTableNames: [],
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        total_pages: 0,
        itemsLength: 0
      },
      localLoading: false,
      dialogMode: 'create',
      selectedItem: null,
      historyPeriodCount: 0,
      e1: 1,
      DIALOG_CREATE: 'DIALOG_CREATE',
      DIALOG_LOG_VIEW: 'DIALOG_LOG_VIEW',
      DIALOG_CHANGE_ENVIROMENT: 'DIALOG_CHANGE_ENVIROMENT',
      headers: [{
        text: 'Caso de uso',
        value: 'caso_de_uso'
      }, {
        text: 'Esquema',
        value: 'destination_scheme'
      }, {
        text: 'Tabla',
        value: 'segmento'
      },
      // { text: 'Tipo exportación', value: 'tipo_exportacion' },
      {
        text: 'Fecha Creación',
        value: 'fecha_creacion'
      },
      // { text: 'Fecha Actualización', value: 'fecha_actualizacion' },
      {
        text: 'Ambiente',
        value: 'environment'
      },
      // { text: 'Carga única', value: 'carga_unica' },
      // { text: 'Frecuencia', value: 'frecuencia' },
      // { text: 'Día', value: 'dia' },
      {
        text: 'Estado',
        value: 'estado'
      }, {
        text: '',
        value: 'options'
      }],
      items: []
    };
  },
  mounted: function mounted() {
    this.getHistory(this.pagination.current, this.pagination.limit);
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['labelCatalog'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: '',
        disabled: true
      }];
    }
  }),
  methods: {
    onTransformationTypeChanged: function onTransformationTypeChanged(newType) {
      this.parentTransformationType = newType;
    },
    onChildLoaded: function onChildLoaded() {
      console.log('🔥 loaded', this.localLoading);
      this.localLoading = false;
    },
    onDownloadLineamientos: function onDownloadLineamientos() {
      var _this = this;
      FilesService.readFileProject('/manuals/lineamientos-script-de-python-v2.pdf').then(function (response) {
        _this.isLoading = false;
        if (response.success) {
          var filename = response.data.name.split('/').pop();
          // Ejemplo de una cadena base64 (PDF en este caso)
          var base64String = response.data.base64.split('base64,')[1]; // Aquí va tu base64

          // Decodifica la cadena base64 a un blob
          var byteCharacters = atob(base64String);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
            type: 'application/pdf'
          }); // Cambia el tipo de archivo si es necesario

          // Crea una URL para el blob
          var url = window.URL.createObjectURL(blob);

          // Crea un enlace de descarga
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename); // Nombre del archivo que se descargará

          // Simula el clic en el enlace para iniciar la descarga
          document.body.appendChild(link);
          link.click();

          // Limpia después de la descarga
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          _this.currentFile = {
            fileLink: null,
            fileName: null,
            contentType: null
          };
          tasks.toast.error('No se pudo descargar el archivo, intentelo mas tarde.');
          //alert(response.message)
        }
      });
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
    },
    onCloseHistory: function onCloseHistory() {
      this.$refs['DIALOG_PROCESS_HISTORY'].onClose();
      this.getHistory(this.pagination.current, this.pagination.limit);
    },
    formatDate: function formatDate(dateString) {
      if (dateString) {
        var options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        };
        return new Date(dateString).toLocaleDateString(undefined, options);
      }
      return '';
    },
    getDateAndHours: function getDateAndHours(created) {
      var date = new Date(created);
      date.setHours(date.getHours() - 5);
      return {
        date: this.$moment(date).format('DD-MM-YYYY'),
        hour: this.$moment(date.setHours(date.getHours() + 5)).format('HH:mm:ss')
      };
    },
    handleStepChange: function handleStepChange(newStep) {
      this.e1 = newStep;
      if (this.e1 === 4) {
        console.log('Final step reached, submitting form...');
        this.getHistory(this.pagination.current, this.pagination.limit);
        this.e1 = 1;
      }
    },
    isBinning: function isBinning(item) {
      if (!item) return false;
      var a = (item.tipo_registro || '').toString().toLowerCase();
      var b = (item.tipo_transformacion || '').toString().toLowerCase();
      return a === 'binning' || b === 'binning';
    },
    openDialog: function openDialog(modalName) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'create';
      var item = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this.dialogMode = mode;
      this.selectedItem = item;
      this.e1 = 1;
      console.log(item, 'item');
      this.setShowLoading(false);
      this.localLoading = true;
      if (this.isBinning(item)) {
        // Mostrar aviso y NO abrir el formulario de edición
        this.$refs['DIALOG_BINNING_LOCK'].onOpen();
        return;
      }

      // Caso normal (no binning): abrir el modal solicitado
      this.$refs[modalName].onOpen();
    },
    closeModalCreate: function closeModalCreate() {
      this.onCloseModal(this.DIALOG_CREATE);
    },
    onCloseModal: function onCloseModal(modalName) {
      this.$refs[modalName].onClose();
    },
    refreshClick: function refreshClick() {
      this.getHistory(this.pagination.current, this.pagination.limit);
    },
    getHistory: function getHistory() {
      var _this2 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pagination.current;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.pagination.limit;
      this.setShowLoading(true);
      var params = {
        user: window.userInfo.email,
        type_export_id: 4,
        page: page,
        page_size: pageSize
      };
      console.log(params, 'params');
      UseCasesService.getProductizeHistory({
        params: params
      }).then(function (_ref) {
        var data = _ref.data;
        var records = data.records || [];

        // 🔧 Normaliza esquema y segmento sin tocar el template
        var clean = function clean(v) {
          return v != null ? String(v) : '';
        };
        _this2.items = records.map(function (it) {
          var esquema = clean(it.destination_scheme).toLowerCase().replace(/_rlink/g, '').trim();
          return _objectSpread(_objectSpread({}, it), {}, {
            destination_scheme: esquema
          });
        });
        console.log(_this2.items, 'items');
        _this2.forbiddenTableNames = _this2.items.map(function (item) {
          return {
            segmento: item.segmento.toLowerCase(),
            usecase_name: item.caso_de_uso.toLowerCase()
          };
        });
        console.log(_this2.forbiddenTableNames, 'forbiddenTableNames');
        // Mapea exactamente lo que devuelve el API
        _this2.pagination.current = data.page; // o page
        _this2.pagination.limit = data.page_size; // o pageSize
        _this2.pagination.total = data.total;
        _this2.pagination.total_pages = data.total_pages;
        _this2.pagination.itemsLength = _this2.items.length; // opcional (si tu paginador lo usa)
      }).finally(function () {
        _this2.setShowLoading(false);
      });
    },
    onPageChange: function onPageChange(newPage) {
      console.log(newPage);
      this.pagination.current = newPage;
      this.getHistory(this.pagination.current, this.pagination.limit);
    },
    onPageSizeChange: function onPageSizeChange(newSize) {
      this.pagination.limit = newSize;
      this.pagination.current = 1;
      this.getHistory(this.pagination.current, this.pagination.limit);
    },
    crear: function crear() {
      console.log('crear');
    },
    syncAttribute: function syncAttribute(attribute) {
      // Lógica para sincronizar un atributo
    },
    fetchAndCombineData: function () {
      var _fetchAndCombineData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var viewsData, params, response1, response2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              viewsData = [];
              params = {
                user: this.serviceAccount
              };
              _context.n = 1;
              return MyAccessService.getObjectAccess('productivize', params);
            case 1:
              response1 = _context.v;
              if (response1 && response1.data) {
                response1.data.forEach(function (element) {
                  viewsData.push({
                    text: element.table.id.replace(':', '.'),
                    value: element.view.projectId + '.' + element.view.datasetId + '.' + element.view.objectId,
                    data: element,
                    status: 'APPROVED'
                  });
                });
              }
              _context.n = 2;
              return MyAccessService.getObjectAccessWithPending('productivize', params);
            case 2:
              response2 = _context.v;
              if (response2 && response2.data) {
                response2.data.forEach(function (element) {
                  viewsData.push({
                    text: element.tableReference.projectId + '.' + element.tableReference.datasetId + '.' + element.tableReference.tableId,
                    value: element.tableReference.projectId + '.' + element.tableReference.datasetId + '.' + element.tableReference.tableId,
                    data: element,
                    status: 'REVISION'
                  });
                });
              }
              return _context.a(2, viewsData);
          }
        }, _callee, this);
      }));
      function fetchAndCombineData() {
        return _fetchAndCombineData.apply(this, arguments);
      }
      return fetchAndCombineData;
    }(),
    viewLog: function viewLog(item, modalName) {
      this.selected = item;
      console.log(item, 'item');
      console.log(modalName, 'modalName');
      this.openDialog(modalName);
    },
    onProcessHistory: function onProcessHistory(item) {
      var _this3 = this;
      this.selected = item;
      this.historyPeriodCount = 0;
      this.openDialog('DIALOG_PROCESS_HISTORY');
      this.$nextTick(function () {
        if (_this3.$refs.period_form && _this3.$refs.period_form.resetPeriodSelection) {
          _this3.$refs.period_form.resetPeriodSelection();
        }
      });
    },
    changeEnviroment: function changeEnviroment(item, modalName) {
      this.selected = item;
      console.log(item);
      this.openDialog(modalName);
    },
    onYesNO: function onYesNO(valor) {
      var _this4 = this;
      if (valor) {
        console.log(valor);
        console.log(this.selected);
        var body = {
          attribute_automate_id: this.selected.automate_id,
          message: 'Cambie de ambiente',
          operator: this.userEmail,
          use_case: this.selected.caso_de_uso,
          env: 'prod',
          table_name: this.selected.segmento,
          origen_ejecucion: 'INCA',
          destination_schema: this.selected.destination_scheme + '_rlink'
        };
        if (this.selected.tipo_registro.toLowerCase() == 'binning') {
          UseCasesService.postSaveTransformedAttributesBinning(body).then(function (response) {
            _this4.setShowLoading(false);
            if (response.ok) {
              console.log(response);
              tasks.toast.success(_this4.translate('success_messages.requested'), _this4.translate('titles.success'));
              _this4.onCloseDialog(_this4.DIALOG_CHANGE_ENVIROMENT);
              _this4.getHistory();
            } else {
              console.log(response);
              tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
              _this4.onCloseDialog(_this4.DIALOG_CHANGE_ENVIROMENT);
            }
          }).catch(function (err) {
            console.error(err);
            tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
            _this4.setShowLoading(false);
          });
        } else {
          UseCasesService.updateTransformedEnv(body).then(function (response) {
            _this4.setShowLoading(false);
            if (response.code === 200) {
              tasks.toast.success(_this4.translate('success_messages.requested'), _this4.translate('titles.success'));
              _this4.onCloseDialog(_this4.DIALOG_CHANGE_ENVIROMENT);
              _this4.getHistory();
            } else {
              tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
            }
          }).catch(function (err) {
            console.error(err);
            tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
            _this4.setShowLoading(false);
            _this4.onCloseDialog(_this4.DIALOG_CHANGE_ENVIROMENT);
          });
        }
      } else {
        this.onCloseDialog(this.DIALOG_CHANGE_ENVIROMENT);
      }
      this.item_delete = null;
    }
  }
};